export function initWpContent(parent) {
  if (!parent) return;

  parent.querySelectorAll('iframe[width][height]').forEach((iframe) => {
    console.log(iframe);
    const w = parseFloat(iframe.getAttribute('width'));
    const h = parseFloat(iframe.getAttribute('height'));
    if (w > 0 && h > 0) {
      iframe.style.setProperty('--width', w);
      iframe.style.setProperty('--height', h);
    }
  });
}

export function initAllWpContent() {
  const blocks = document.querySelectorAll('.js-wp-content');
  blocks.forEach((block) => initWpContent(block));
}
